<div class="modal-header">
  <h4 class="modal-title h5" translate>Documentation</h4>
  <button type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  @if (isLoading) {
    <div class="content-loading d-flex align-items-center justify-content-center py-5">
      <div class="text-center">
        <div class="mb-2 display-4 text-primary">
          <span class="fa-solid fa-spinner fa-spin"></span>
        </div>
      </div>
    </div>
  }
  @for (doc of documentations; track doc) {
    <div class="list-group">
      <a (click)="onDownloadDocumentation(doc)" style="cursor: pointer" class="list-group-item list-group-item-action">
        <div class="row align-items-center">
          <div class="col">
            <b class="truncate" style="max-width: 80%;" [innerText]="doc"></b>
          </div>
          <div class="col-auto">
            <i class="fa-solid fa-arrow-down"></i>
          </div>
        </div>
      </a>
    </div>
  }

  <!-- Fallback message -->
  @if (showFallBackText) {
    <div class="alert alert-info text-center mb-0">
      <span [innerText]="fallbackText"></span>
    </div>
  }
</div>

<scitis-modal-footer
  [okButtonText]="closeButtonText"
  [showCancelButton]="false"
  (okButtonPressed)="onClose()">
</scitis-modal-footer>
